<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<div class="figure">
<img alt="me - good one for books" src="Images/file0.jpg" style="width:2.27986in;height:3.31181in"/>
<p class="caption">me - good one for books</p>
</div>
<p>This is Margaret’s fourth book, published by Austin Macauley. This one is different to the others in that it is in diary-format, and written during her three months in a French villa, in the rural town of Aubusson, in the southern part of France. Margaret had her first book published at the age of 68, and from then she has been inspired to keep writing and sharing her unique style. Her children’s books are a delight to the older readers as well as the targeted young readers – which makes her writing style widely appreciated. This book will appeal to those that want the adventure of living in a French villa, or those that can only ever dream of it!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?fbe3b7a0